import React, { useMemo, useState } from 'react';
import { SocialUserInfo } from '../profile-views/ProfileViews';
import {
    Espin_Player_Profile,
    FollowerCollegesForPlayersDocument,
    FollowerCollegesForPlayersQuery,
    FollowerCollegesForPlayersQueryVariables,
    GetChildProfilesDocument,
    GetChildProfilesQuery,
    GetChildProfilesQueryVariables,
} from '../../../generated/spin-graphql';
import { ParentChildDropdown } from '../ParentChildDropdown';
import { useAppState } from 'client/providers/AppProvider';
import { useAuthenticatedQuery } from 'client/hooks';
import { PlayerFollowers } from './PlayerFollowers';
import { CONVERT_TO_MILES } from 'shared/shared.constants';

type Props = {};

export type PlayerFollowingInfo = {
    player: Espin_Player_Profile;
    closeColleges?: SocialUserInfo[];
    farColleges?: SocialUserInfo[];
    totalClose: number;
    totalFar: number;
};
const backUpDate = new Date().toISOString();
export const ParentFollowers: React.FC<Props> = ({}) => {
    const { user } = useAppState();

    const [selectedPlayer, setSelectedPlayer] = useState(0);

    const { isReady: childProfileReady, data: childProfileData } = useAuthenticatedQuery<
        GetChildProfilesQuery,
        GetChildProfilesQueryVariables
    >({
        query: GetChildProfilesDocument,
        variables: useMemo(() => ({ id: user?.id }), [user]),
        pause: !user,
    });

    const { isReady, data } = useAuthenticatedQuery<
        FollowerCollegesForPlayersQuery,
        FollowerCollegesForPlayersQueryVariables
    >(
        {
            query: FollowerCollegesForPlayersDocument,
            variables: {
                closeSearch: {
                    address: {
                        location: {
                            _st_d_within: {
                                distance: 100 * CONVERT_TO_MILES,
                                from: {
                                    type: 'Point',
                                    coordinates: childProfileData?.espin_parent_profile?.[0]?.child_profiles[
                                        selectedPlayer
                                    ].address.location?.['coordinates'] ?? [0, 0],
                                },
                            },
                        },
                    },
                },
                farSearch: {
                    _not: {
                        address: {
                            location: {
                                _st_d_within: {
                                    distance: 100 * CONVERT_TO_MILES,
                                    from: {
                                        type: 'Point',
                                        coordinates: childProfileData?.espin_parent_profile?.[0]?.child_profiles[
                                            selectedPlayer
                                        ].address.location?.['coordinates'] ?? [0, 0],
                                    },
                                },
                            },
                        },
                    },
                },
                playerUserId: user?.parent_profile?.child_profiles?.[selectedPlayer]?.user_id,
                date: user.last_login ?? backUpDate,
            },
            pause: !childProfileReady,
        },
        ['espin_follow'],
    );
    const { close_aggregate, close_follow, far_aggregate, far_follow } = data ?? {};
    const listOfFollows = useMemo(() => data?.following.map((f) => f.college_id), [data?.following]);
    if (!childProfileReady || !isReady) {
        return <></>;
    }

    return (
        <>
            {childProfileData.espin_parent_profile[0].child_profiles.length > 1 && (
                <div className="parent-dropdown-container">
                    <ParentChildDropdown
                        playerInfo={childProfileData.espin_parent_profile}
                        value={childProfileData.espin_parent_profile[0].child_profiles[selectedPlayer]}
                        onChange={(value) => {
                            setSelectedPlayer(value);
                        }}
                    />
                </div>
            )}

            {isReady && (
                <PlayerFollowers
                    listOfFollows={listOfFollows}
                    closeColleges={close_follow}
                    farColleges={far_follow}
                    newFollowers={close_aggregate?.aggregate.count + far_aggregate?.aggregate.count}
                    totalFollowers={close_follow.length + far_follow.length}
                    selectedPlayer={selectedPlayer}
                />
            )}
        </>
    );
};
